// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__o2spy","row":"styles_row__8r57U"};